module.exports = __webpack_public_path__ + "static/media/markerPin.d9d208a8.svg";